<template>
  <div class="p-2 pb-0 flex flex-col gap-2">
    <div
      class="flex items-center gap-1 text-error-300 bg-neutral-900 rounded-sm py-2 pl-3 pr-4">
      <NuxtIcon
        name="mdi:warning"
        :alt="$t('main.imageAltTexts.KYCErrorIcon')"
        class="w-3 h-3 text-warning-300 shrink-0" />
      <p class="text-xs text-error-300">
        {{ $t("main.kycRequiredNotice.kycRequired") }}
      </p>
    </div>
    <div class="text-neutral-300 text-xs">
      <p>
        <span class="font-bold">{{
          $t("main.kycRequiredNotice.dataProtectionInfoTop")
        }}</span>
        <i18n-t
          keypath="main.kycRequiredNotice.dataProtectionInfoMid"
          scope="global">
          <template #email>
            <a
              href="mailto:dpo@gfal.com"
              class="text-primary-500 underline cursor-pointer"
              >dpo@gfal.com</a
            >
          </template>
          <template #privacyPolicy>
            <NuxtLinkLocale
              :to="`/legal/privacy-policy`"
              target="_blank"
              class="text-primary-500 underline cursor-pointer">
              {{ $t("main.kycRequiredNotice.dataPrivacyPolicy") }}
            </NuxtLinkLocale>
          </template>
        </i18n-t>
      </p>
      <p class="mt-2">
        {{ $t("main.kycRequiredNotice.dataSubmitConsent") }}
      </p>
    </div>
  </div>
</template>
